import React from 'react';

export const NotFound = () => (
  <div>
    <h3>404 page not found</h3>
    <p>Entschuldigung, die Seite konnte nicht gefunden werden.</p>
  </div>
    )


// WEBPACK FOOTER //
// ./src/NotFound.js